import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  "https://zssjcgfnyfewlgwqsinj.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpzc2pjZ2ZueWZld2xnd3FzaW5qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ5NDEyMDYsImV4cCI6MjA5MDUxNzIwNn0.G-5mPa5XZCpglQKpPh6S5atUKZX8JwL90bF7gv54Uzo",
  { auth: { persistSession: true, autoRefreshToken: true } }
);
